import { faUser } from '@fortawesome/free-regular-svg-icons';
import {
  faInfoCircle,
  faLink,
  faReply
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmptyList from 'components/common/EmptyList';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import { PrioritySelect } from 'hooks/useTicketsTable';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ContinuedTickets = ({ continuedTickets = [] }) => {
  return (
    <>
      <Flex alignItems="end" className="mb-4 w-100">
        <h3 className="m-0 me-2">Tickets Continuados</h3>
        <OverlayTrigger
          overlay={
            <Tooltip>
              Tickets continuados são tickets que foram criados a partir de um
              ticket que já foi encerrado e recebeu uma resposta tardia.
            </Tooltip>
          }
        >
          <span>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
        </OverlayTrigger>
      </Flex>

      {continuedTickets.length > 0 ? (
        <div className="d-flex flex-column gap-3">
          {continuedTickets.map((ticket, index) => (
            <TicketCard key={index} ticket={ticket} />
          ))}
        </div>
      ) : (
        <EmptyList imgSize={250} />
      )}
    </>
  );
};

const TicketCard = ({ ticket }) => {
  const {
    id,
    code,
    subject,
    customer,
    contactCustomer,
    status,
    priority,
    parentTicket,
    answered,
    description
  } = ticket;

  return (
    <Card className="shadow-sm hover-shadow transition-base">
      <Card.Body className="p-3">
        <Row className="align-items-center">
          {/* Coluna Esquerda - Código, Assunto e Cliente */}
          <Col xs={12} md={7} lg={8}>
            {/* Header com Código e Ícones */}
            <Flex alignItems="center" className="mb-2">
              {parentTicket && (
                <OverlayTrigger
                  overlay={
                    <Tooltip>Ticket originado de: #{parentTicket.code}</Tooltip>
                  }
                >
                  <span className="me-2 text-primary">
                    <FontAwesomeIcon icon={faLink} />
                  </span>
                </OverlayTrigger>
              )}
              <Link
                to={`/tickets/${id}`}
                className="fw-bold fs-0 text-primary me-2"
              >
                #{code}
              </Link>
              {answered && (
                <OverlayTrigger
                  overlay={<Tooltip>Respondido pelo solicitante</Tooltip>}
                >
                  <span className="text-success">
                    <FontAwesomeIcon icon={faReply} />
                  </span>
                </OverlayTrigger>
              )}
            </Flex>

            {/* Assunto do Ticket */}
            <div className="mb-2">
              <Link
                to={`/tickets/${id}`}
                className="text-900 fw-semibold fs-0 hover-primary text-decoration-none"
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  lineHeight: '1.4'
                }}
              >
                {subject}
              </Link>
            </div>

            {/* Informações do Cliente */}
            <Flex alignItems="center" className="gap-3">
              <Link
                to={`/registration/customers/${customer.id}`}
                className="text-800 d-flex align-items-center gap-2 text-decoration-none hover-primary"
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                <FontAwesomeIcon icon={faUser} className="text-600" />
                <span className="fs--1">
                  {customer.type === 'JURIDICAL_PERSON'
                    ? customer.fantasyName
                    : customer.name}
                </span>
              </Link>
              {contactCustomer && (
                <span className="fs--2 text-600">
                  • Contato: {contactCustomer.name}
                </span>
              )}
            </Flex>
          </Col>

          {/* Coluna Direita - Status e Prioridade */}
          <Col xs={12} md={5} lg={4}>
            <Flex
              direction="column"
              alignItems="end"
              className="gap-3 mt-3 mt-md-0"
            >
              <SoftBadge
                style={{ backgroundColor: status.color }}
                className="fs-0"
              >
                {status.description}
              </SoftBadge>
              <Flex alignItems="center" className="gap-2">
                <span className="text-600 fs--1">Prioridade:</span>
                <PrioritySelect
                  title={priority.description}
                  color={priority.color}
                  data={priority.data}
                />
              </Flex>
            </Flex>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ContinuedTickets;
